import { Button, Modal, Form, Input, message, Select } from "antd";
import { updateUser, country } from "@/apis/user";
import { useDispatch } from "react-redux";
import intl from "react-intl-universal";
import { useEffect, useState } from "react";
import { setUserInfo } from "@/store/modules/user";
const { TextArea } = Input;
const { Option } = Select;
const InputModal = ({ isOpen, setIsOpen, userInfo, isUpdate, setIsUpdata }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const msg = intl.get("Please complete this required field");
  const [countryList, setCountryList] = useState([]);
  const getSelectList = () => {
    // 国家下拉
    country()
      .then((res) => {
        setCountryList(res.data || []);
      })
      .catch((err) => { });
  };
  // 编辑
  const onFinish = (values) => {
    updateUser(values)
      .then((res) => {
        message.success(intl.get("Operate successfully"));
        setIsOpen(false);
        setIsUpdata(!isUpdate);
        dispatch(
          setUserInfo({
            nickname: form.getFieldValue('nickname'),
          })
        );
      })
      .catch((err) => { });
  };
  useEffect(() => {
    if (isOpen) {
      getSelectList();
      form.setFieldsValue({
        username: userInfo.username,
        country: userInfo.country,
        nickname: userInfo.nickname,
        organization: userInfo.organization,
        researchAspect: userInfo.researchAspect,
        signature: userInfo.signature,
      });
    } else {
      form.setFieldsValue({
        username: userInfo.username,
        country: "",
        nickname: "",
        organization: "",
        researchAspect: "",
        signature: "",
      });
    }
  }, [isOpen]);


  return (
    <Modal
      title={intl.get("Edit Information")}
      width={500}
      open={isOpen}
      footer={null}
      onCancel={() => {
        setIsOpen(false);
      }}
    >
      <Form
        form={form}
        style={{ marginTop: 30 }}
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item
          label={intl.get("Register.Nickname")}
          name="nickname"
          rules={[
            {
              required: true,
              message: msg,
            },
          ]}
        >
          <Input maxLength={30}/>
        </Form.Item>
        <Form.Item
          label={intl.get("Register.Country/Region")}
          name="country"
          rules={[
            {
              required: true,
              message: msg,
            },
          ]}
        >
          <Select allowClear showSearch>
            {countryList.map((item) => (
              <Option key={item} value={item}>
                {item}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label={intl.get("Register.Organization")}
          name="organization"
          rules={[
            {
              required: true,
              message: msg,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={intl.get("Register.Research aspect")}
          name="researchAspect"
          rules={[
            {
              required: true,
              message: msg,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={intl.get("User.Biography")}
          name="signature"
        >
          <TextArea rows={3} placeholder="maxLength is 140" maxLength={140} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            {intl.get("Share.Submit")}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default InputModal;
